module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAABP0lEQVQ4Ea3BMYjNcRwA8M//7/sy3LtB3YIbbEqXzaDbJBflNqUYbqIsN8liVebTXciV5QayyeAui0wGBtRN6MItEjmduu79/eo7uKfey3t8PtWph8efYdK/WQ1M4gGWURncIcyGdBePDGccl2ppr95GMaK3A2hC6kgLuIdVXMRHfEKN3XiJGSziNObRUYTUSOO4ihVMYB/e4DFO4him0MYHqVaEbk+wgTtYwia+4ie+4Dwu4zYO2iGkSupgESPYj3W0cRgvcAv3cQTv7BBSLd2Q5vw2hk38wBXpgj+EVOnts/52KULakm5iGtv6C7zCCXxXhG7v8dzfWZMqRUgt6brBtRW1/ySkLekajqLSX4M1zGBDEbq1MYaO/mp8kxpFSC1p1uBGFbW0bnhvUYV0DntQG0yDCbQCT3EGZw3v9S8oo0E0mLPk4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/tzgg.png
// module id = p27o
// module chunks = 68